<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
  <child-header [title]="title"  (closeEvent)="close()"></child-header>
  <div #ParentWrapper class="subBlockContent" id="financial-summary" >
    <loading-screen *ngIf="!loadContent" [scrollAfterLoading]="true" [showBlurTable]="true" backDropWidth="985"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
    <div *ngIf="loadContent"  class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      <div>
        <label class="tablelabel label-margin text-capitalize" *ngIf="editCartId != cartId">{{quoteName}}</label>
        <span id="edit-icon" *ngIf="editCartId != cartId" class="basic-icon edit-icon" ngbTooltip="Rename Finance Quote Name" placement="bottom"
          (click)="setEditQuoteCart(cartId)">
        </span>
        <div id="editCartNamePopup" *ngIf="editCartId == cartId">
          <input #editCartId class="edit-input" type="text" [(ngModel)]="editQuoteName" (input)="validateCartName($event)"
            (keyup.enter)="confirmQuoteNameValue()" *ngIf="editCartId == cartId">
          <button class="button button-red button-mid editBtn-cartName" (click)="confirmQuoteNameValue()"
            *ngIf="editCartId == cartId">Ok</button>
          <button class="button button-red button-mid editBtn-cartName" (click)="setEditQuoteCart('0')" *ngIf="editCartId == cartId">Cancel</button>
        </div>
        <div class="mat-elevation-z8 shared-outer-wrapper">
          <table class="white" style="width: 100%" nowrap>
            <thead>
                <tr class="row cart-title-wrapper">
                  <th scope="col" style="width: 21%; padding-left: 15px">OPTION</th>
                  <th scope="col" class="align-right" style="width: 25%;">FINANCED AMOUNT</th>
                  <th scope="col" class="align-right" style="width: 28%;">MONTHLY RECURRING CHARGES</th>
                  <th scope="col" class="align-right" style="width: 25%; padding-right: 15px">TOTAL REPAYMENTS</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="quote">
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 21%; padding-left: 15px">{{quote.termInMonths}} Rental</td>
                    <td class="align-right" style="width: 25%;">{{ (totalPrice + additionalChargeTotalPrice) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <td class="align-right" style="width: 28%;">{{ (selectedTerm?.amount - passThroughChargeTotalPrice) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <td class="align-right" style="width: 25%; padding-right: 15px">{{ ((selectedTerm?.amount - passThroughChargeTotalPrice) * selectedTerm?.termId) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="passThroughChargeTotalPrice > 0">
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 21%; padding-left: 15px">Monthly Passthrough Charges</td>
                    <td class="align-right" style="width: 25%;"></td>
                    <td class="align-right" style="width: 28%;">{{ passThroughChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    <td class="align-right" style="width: 25%; padding-right: 15px">{{ (passThroughChargeTotalPrice * selectedTerm?.termId) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                  </tr>
                </ng-container>
                <ng-container>
                  <tr class="row product-wrapper product-content-wrapper">
                    <td style="width: 21%; padding-left: 15px"><b>Total:</b></td>
                    <td class="align-right" style="width: 25%;"></td>
                    <td class="align-right" style="width: 28%;"><b>{{ selectedTerm?.amount | currency:'AUD':'symbol-narrow':'.2-2'}}</b></td>
                    <td class="align-right" style="width: 25%; padding-right: 15px"><b>{{ (selectedTerm?.amount * selectedTerm?.termId) | currency:'AUD':'symbol-narrow':'.2-2'}}</b></td>
                  </tr>
                </ng-container>
              </tbody>
          </table>
        </div>
  
        <div style="margin-top: 20px;">
          <label class="tablelabel">Equipment / Service Purchase</label>
        </div>
      
        <div class="mat-elevation-z8 shared-outer-wrapper mTable">
          <!-- <mat-table [dataSource]="dataSourceItems">
            <ng-container matColumnDef="SKU">
              <mat-header-cell *matHeaderCellDef class="mat-flex-2"> SKU </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.sku}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DESCRIPTION">
              <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.description}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="QTY">
              <mat-header-cell *matHeaderCellDef class="qty-align"> QTY </mat-header-cell>
              <mat-cell *matCellDef="let element" class="qty-align"> {{element.quantity}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="UNITPRICE">
              <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">
                {{element.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LINEPRICE">
              <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [class.totalprice]="!element.id && financeType != 'enduser'"
                class="align-right">
                {{element.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SELLINGPRICE" *ngIf="quote?.financeType == 2">
              <mat-header-cell *matHeaderCellDef class="align-right"> SELL PRICE </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">
                {{element.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SELLINGLINEPRICE" *ngIf="quote?.financeType == 2">
              <mat-header-cell *matHeaderCellDef class="align-right"> LINE SELL PRICE </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">
                {{element.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table> -->
          <table class="white table-width" nowrap>
              <thead>
                  <tr class="row cart-title-wrapper">
                    <th scope="col" style="width: 15%; padding-left: 15px">SKU</th>
                    <th scope="col" style="width: 30%;">DESCRIPTION</th>
                    <th scope="col" class="align-center" style="width: 10%;">QTY</th>
                    <th scope="col" class="align-center" style="width: 10%;">UNIT PRICE</th>
                    <th scope="col" class="align-right" style="width: 10%;">LINE PRICE</th>
                    <th scope="col" class="align-right" style="width: 11%;">SELL PRICE</th>
                    <th scope="col" class="align-right" style="width: 13%;">LINE SELL PRICE</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of shoppingCartItems">
                    <tr class="row product-wrapper product-content-wrapper">
                      <td style="width: 15%; padding-left: 15px">{{item.sku}}</td>
                      <td style="width: 30%;">{{item.description}}</td>
                      <td class="align-center" style="width: 10%;">{{item.quantity}}</td>
                      <td class="align-center" style="width: 10%;">{{item.unitPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="align-right" style="width: 10%;">{{item.linePrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="align-right" style="width: 11%;">{{item.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="align-right" style="width: 13%;"> {{item.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    </tr>
                  </ng-container>
                </tbody>
          </table>
          <div class="totalrow">
            <p class="totaltext">FINANCED ITEM TOTAL</p>
            <p class="totalprice">{{totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
          </div>
          <div class="totalrow">
            <p class="totaltext" *ngIf="selectedTerm?.termId!=1">{{selectedTerm?.description}}</p>
            <p class="totalprice" *ngIf="selectedTerm?.termId!=1">{{selectedTerm?.amount | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</p>
            <p class="totaltext-manual" *ngIf="selectedTerm?.termId==1">&nbsp;</p>
            <p class="totalprice-manual" *ngIf="selectedTerm?.termId==1">{{selectedTerm?.description | uppercase}}</p>
          </div>
        </div>
      </div>

      <div class="table-margin" *ngIf="additionalCharges[0]?.description">
        <label class="tablelabel">Additional Once Off Charges</label>
        <div class="mat-elevation-z8 shared-outer-wrapper">
          <!-- <mat-table [dataSource]="dataSourceAdditionalCharge">
            <ng-container matColumnDef="SKU">
              <mat-header-cell *matHeaderCellDef> SKU </mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.sku}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DESCRIPTION">
              <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.description}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="QTY">
              <mat-header-cell *matHeaderCellDef class="align-right"> QTY </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">{{element.quantity}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="UNITPRICE">
              <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">
                {{element.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LINEPRICE">
              <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">
                {{element.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumnsAdditional"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumnsAdditional;"></mat-row>
          </mat-table> -->
          <table class="white table-width" nowrap>
              <thead>
                  <tr class="row cart-title-wrapper">
                    <th scope="col" style="width: 15%; padding-left: 15px">SKU</th>
                    <th scope="col" style="width: 53%">DESCRIPTION</th>
                    <th scope="col" class="align-center" style="width: 10%">QTY</th>
                    <th scope="col" class="align-center" style="width: 10%">UNIT PRICE</th>
                    <th scope="col" class="align-right" style="width: 10%">LINE PRICE</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let charge of additionalCharges">
                    <tr class="row product-wrapper product-content-wrapper">
                      <td style="width: 15%; padding-left: 15px">{{charge.sku}}</td>
                      <td style="width: 53%">{{charge.description}}</td>
                      <td class="align-center" style="width: 10%">{{charge.quantity}}</td>
                      <td class="align-center" style="width: 10%">{{charge.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="align-right" style="width: 10%">{{charge.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    </tr>
                  </ng-container>
                </tbody>
          </table>
          <div class="totalrow">
            <p class="totaltext">ADDITIONAL ONCE OFF CHARGES TOTAL</p>
            <p class="totalprice">{{additionalChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
          </div>
        </div>
      </div>

      <!-- <div style="margin-top: 18px;">
        <label class="tablelabel">Bank Details</label>
        <div class="row">
          <mat-form-field [floatLabel]="'always'" class="col-md-4">
            <input matInput placeholder="NAME" disabled [value]="accountName">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" class="col-md-4">
            <input matInput placeholder="BSB" disabled [value]="bsb">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" class="col-md-4">
            <input matInput placeholder="ACCOUNT" disabled [value]="accountNumber">
          </mat-form-field>
        </div>
      </div> -->

      <div class="table-margin" *ngIf="passThroughCharges[0]?.description">
        <label class="tablelabel">Monthly Passthrough Recurring Charges</label>
        <div class="mat-elevation-z8 shared-outer-wrapper">
          <!-- <mat-table [dataSource]="dataSourcePastThrough">
            <ng-container matColumnDef="SKU">
              <mat-header-cell *matHeaderCellDef> SKU </mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.sku}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DESCRIPTION">
              <mat-header-cell *matHeaderCellDef class="mat-flex-2"> DESCRIPTION </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-flex-2"> {{element.description}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="QTY">
              <mat-header-cell *matHeaderCellDef class="align-right"> QTY </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">{{element.quantity}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="UNITPRICE">
              <mat-header-cell *matHeaderCellDef class="align-right"> UNIT PRICE </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">
                {{element.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LINEPRICE">
              <mat-header-cell *matHeaderCellDef class="align-right"> LINE PRICE </mat-header-cell>
              <mat-cell *matCellDef="let element" class="align-right">
                {{element.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}} </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumnsPass"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumnsPass;"></mat-row>
          </mat-table> -->
          <table class="white table-width" nowrap>
              <thead>
                  <tr class="row cart-title-wrapper">
                    <th scope="col" style="width: 15%; padding-left: 15px;">SKU</th>
                    <th scope="col" style="width: 53%">DESCRIPTION</th>
                    <th scope="col" class="align-center" style="width: 10%">QTY</th>
                    <th scope="col" class="align-center" style="width: 10%">UNIT PRICE</th>
                    <th scope="col" class="align-right" style="width: 10%">LINE PRICE</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let charge of passThroughCharges">
                    <tr class="row product-wrapper product-content-wrapper">
                      <td style="width: 15%; padding-left: 15px;">{{charge.sku}}</td>
                      <td style="width: 53%">{{charge.description}}</td>
                      <td class="align-center" style="width: 10%">{{charge.quantity}}</td>
                      <td class="align-center" style="width: 10%">{{charge.sellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                      <td class="align-right" style="width: 10%">{{charge.lineSellPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                    </tr>
                  </ng-container>
                </tbody>
          </table>
          <div class="totalrow">
            <p class="totaltext">MONTHLY PASSTHROUGH RECURRING CHARGES</p>
            <p class="totalprice">{{passThroughChargeTotalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</p>
          </div>
        </div>
      </div>

      <div>
        <label class="tablelabel">Application Contact</label>
        <div class="row">
          <mat-form-field [floatLabel]="'always'" class="col-md-4">
            <input matInput placeholder="Name" disabled [value]="quote?.contactName">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" class="col-md-4">
            <input matInput placeholder="Email" disabled [value]="quote?.email">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" class="col-md-4">
            <input matInput placeholder="Phone" disabled [value]="quote?.phone">
          </mat-form-field>
        </div>
        <label class="tablelabel">Borrower Details</label>
        <div class="row">
          <mat-form-field [floatLabel]="'always'" class="col-md-6">
            <input matInput placeholder="Company Name" disabled [value]="quote?.companyName">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'" class="col-md-6">
            <input matInput placeholder="Abn" disabled [value]="quote?.abn">
          </mat-form-field>
        </div>
      </div>
      <div class="button-center">
        <button class="button button-red button-large check-out-finance" (click)="modifyQuote()">Modify Quote</button>
      </div>

    </div>
  </div>
</div>